import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLargeRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconChevronLargeRight"><Path fillRule="evenodd" clipRule="evenodd" d="M9.36681 2.10546C9.72284 1.89377 10.1831 2.01078 10.3948 2.36681L15.8948 11.6168C16.0352 11.853 16.0352 12.1472 15.8948 12.3834L10.3948 21.6334C10.1831 21.9895 9.72284 22.1065 9.36681 21.8948C9.01078 21.6831 8.89377 21.2228 9.10546 20.8668L14.3776 12.0001L9.10546 3.13342C8.89377 2.77739 9.01078 2.31716 9.36681 2.10546Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLargeRight;
